export default "__VITE_ASSET__CXRB0yaX__"